import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=374c2d1b&scoped=true&"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&id=374c2d1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c2d1b",
  null
  
)

export default component.exports